import React, { FC } from 'react';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import ReactMarkdown from 'react-markdown';
import styles from './MarkdownRenderer.module.scss';

interface Props {
  body: string;
  entryId?: string;
}

const MarkdownRenderer: FC<Props> = ({ body, entryId }) => {
  const inspectorProps = useContentfulInspectorMode({ entryId });
  return (
    <div
      className={styles.markdown}
      {...(entryId ? inspectorProps({ fieldId: 'markdown' }) : null)}
    >
      <ReactMarkdown linkTarget='_blank' children={body} />
    </div>
  );
};

export default MarkdownRenderer;
